import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Lastmenu2 from './LastMenu2';
import you from '../images/boy.png';
import bot from '../images/happy.png';

const Feedback = () => {
    const inputRef = useRef(null);
    const [showFrame, setShowFrame] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [feedback, setFeedback] = useState("");
    const [error, setError] = useState("");
    const [time] = useState(new Date());

    // Auto-focus input and show submit button on load
    useEffect(() => {
        inputRef.current?.focus();
        setShowButton(true);
    }, []);

    const handleChange = (e) => {
        const value = e.target.value;
        if (/^[A-Za-z\s]*$/.test(value)) {
            setFeedback(value);
            setError("");
        } else {
            setError("Please enter valid feedback (only letters and spaces).");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (feedback.trim().length === 0) {
            setError("Please enter valid feedback.");
            return;
        }

        try {
            const response = await axios.post("https://dairy-api-kzjx.onrender.com/feedback", { feedback });

            if (response.status === 200 && response.data.message === "Feedback submitted successfully") {
                setShowFrame(true);
                setFeedback(""); // Clear input
            } else {
                setError("Failed to submit feedback. Please try again.");
            }
        } catch (error) {
            setError("Error: " + (error.response?.data?.error || "Failed to connect to the server."));
        }
    };

    return (
        <>
            <div className="you-time Feedback">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
            </div>
            <div className="you-message">
                <div className="frame2 Feedback"><b>Feedback</b></div>
            </div>

            <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>

            <div className="frame1 animated-frame">
                <div className="box1">
                    Please provide your valuable feedback
                    <input 
                        type='text' 
                        className='input-text' 
                        placeholder='Enter your feedback here'
                        value={feedback}
                        onChange={handleChange}
                        ref={inputRef}
                    />
                    {error && <p className="error">{error}</p>}
                    {showButton && (
                        <div style={{ textAlign: 'center' }}>
                            <button className='menu-btn' onClick={handleSubmit}>Submit</button>
                        </div>
                    )}
                </div>
            </div>

            {showFrame && (
                <>
                    <div className="you-time animated-frame">
                        <img src={you} alt="boy" className="boy" />
                        You {time?.toLocaleTimeString()}
                    </div>
                    <div className="you-message">
                        <div className="frame2 animated-frame"><b>Submit</b></div>
                    </div>

                    <div className='chatbot'>
                        <img src={bot} alt="bot" className="bot" />
                        <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>

                    <div className="frame1 animated-frame">
                        <div className="box1">
                            Thank you for your feedback!
                        </div>
                    </div>
                    <Lastmenu2 />
                </>
            )}
        </>
    );
};

export default Feedback;
